// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5600 ? "05f6971a" : chunkId) + "." + {"2297":"263c139de0bc1b51","5600":"75011592d2c54421"}[chunkId] + ".js";
};